export const FEATURED_TAGS = [
  "Cellular",
  "LoRa",
  "Satellite",
  "Wi-Fi",
  "GPS/GNSS",
  "Low Power",
  "Machine Learning",
];

export function getTagNameByValue(value: string) {
  let tag = value
    .replaceAll("-", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const exceptionMap: { [key: string]: string } = {
    Ai: "AI",
    Esp32: "ESP32",
    "Gps Gnss": "GPS/GNSS",
    Iot: "IoT",
    Lipo: "LiPo",
    Json: "JSON",
    Jsonata: "JSONata",
    Lora: "LoRa",
    Micropython: "MicroPython",
    "Note C": "note-c",
    Ntn: "NTN",
    Stm32: "STM32",
    "Wi Fi": "Wi-Fi",
  };

  if (exceptionMap[tag]) {
    tag = exceptionMap[tag];
  }

  return tag;
}
